export default {
    data() {
        return {
           blogItems:  [
               {
                   id: 1,
                   blogImg: require(`@/assets/img/blog/blog-1.jpg`),
                //    listImg:require(`@/assets/img/course/list/course_list_1.jpeg`),
                   title: 'The Challenge Of Global Learning In Public Education',
                   authorImg: require(`@/assets/img/course/teacher/teacher-1.jpg`),
                   authorName: 'Jim Séchen',
                   category: 'Art & Design',
                   date:'April 02, 2022',
                   color:'green'
               },
               {
                   id: 2,
                   blogImg: require(`@/assets/img/blog/blog-2.jpg`),
                //    listImg:require(`@/assets/img/course/list/course_list_1.jpeg`),
                   title: 'Exactly How Technology Can Make Reading Better',
                   authorImg: require(`@/assets/img/course/teacher/teacher-2.jpg`),
                   authorName: 'Barry Tone',
                   category: 'UX Design',
                   date:'January 05, 2022',
                   color:'sky-blue'
               },
               {
                   id: 3,
                   blogImg: require(`@/assets/img/blog/blog-3.jpg`),
                //    listImg:require(`@/assets/img/course/list/course_list_1.jpeg`),
                   title: 'New Chicago school budget relies on state pension',
                   authorImg: require(`@/assets/img/course/teacher/teacher-3.jpg`),
                   authorName: 'Samuel Serif',
                   category: 'Development',
                   date:'February 08, 2022',
                   color:'green',
               },
               {
                   id: 4,
                   blogImg: require(`@/assets/img/blog/blog-4.jpg`),
                //    listImg:require(`@/assets/img/course/list/course_list_1.jpeg`),
                   title: 'Google Ads certifications: Are they worth it?',
                   authorImg: require(`@/assets/img/course/teacher/teacher-4.jpg`),
                   authorName: 'Elon Gated',
                   category: 'Marketing',
                   date:'March 01, 2022',
                   color:'blue'
               },
               {
                   id: 5,
                   blogImg: require(`@/assets/img/blog/blog-5.jpg`),
                //    listImg:require(`@/assets/img/course/list/course_list_1.jpeg`),
                   title: '14 Facebook Ad Examples for Ad Creative Inspiration',
                   authorImg: require(`@/assets/img/course/teacher/teacher-5.jpg`),
                   authorName: 'Brian Cumin',
                   category: 'Data Science',
                   date:'September 15, 2022',
                   color:'orange'
               },
               {
                   id: 6,
                   blogImg: require(`@/assets/img/blog/blog-6.jpg`),
                //    listImg:require(`@/assets/img/course/list/course_list_1.jpeg`),
                   title: 'How to manage Facebook ads for clients the right way',
                   authorImg: require(`@/assets/img/course/teacher/teacher-6.jpg`),
                   authorName: 'Pelican Steve',
                   category: 'Audio & Music',
                   date:'October 25, 2022',
                   color:'pink'
               },
           ]
        }
    }
}